/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/maximize-2-flipped";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Maximize2Flipped";
export { I as Maximize2Flipped };
